/**
 * Converts update intent response to readable object for merchant
 * @param {object} response
 * @returns {objcet} datatToMerchant object
 */
function getDataToMerchant(response) {
  let dataToMerchant;
  if (response.purchasedata) {
    const { callId, enckey, intentId, paymentMethodType, purchasedata, status } = response;
    dataToMerchant = {
      callId: callId || intentId,
      enckey,
      paymentMethodType,
      purchasedata,
      status
    };
  } else {
    const {
      callid,
      country,
      encKey,
      encPaymentData,
      intentId,
      partialPaymentInstrument,
      partialShippingAddress,
      paymentMethodType,
      postalCode,
      responseStatus
    } = response;
    dataToMerchant = {
      callid: callid || intentId,
      country,
      encKey,
      encPaymentData,
      partialPaymentInstrument,
      partialShippingAddress,
      paymentMethodType,
      postalCode,
      responseStatus
    };
  }
  return dataToMerchant;
}

export default getDataToMerchant;
